import DashboardFollowersTable from "./DashboardFollowersTable";

export default DashboardFollowersTable;
